import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAnalytics, logEvent as firebaseLogEvent } from "firebase/analytics";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const remoteConfig =
  typeof window !== "undefined" ? getRemoteConfig(app) : null;
if (remoteConfig) {
  remoteConfig.settings = {
    fetchTimeoutMillis: 60000,
    minimumFetchIntervalMillis: 60000,
  };
  remoteConfig.defaultConfig = {
    udhaar_web_login_condition: true,
    rupin_web_wallet_nonideal: false,
  };
}

export const getLoginDesign = async () => {

  if (!remoteConfig) {
    return {
      udhaar_web_login_condition: true
    };
  }
  try {
    await fetchAndActivate(remoteConfig);
    const udhaar_web_login_condition = getValue(
      remoteConfig,
      "udhaar_web_login_condition"
    ).asBoolean();

    return {
      udhaar_web_login_condition,
    };
  } catch (err) {
    return {
      udhaar_web_login_condition: true,
    };
  }
};



export const getWalletOnboardingVariant = async () => {
  if (!remoteConfig) return false;
  try {
    await fetchAndActivate(remoteConfig);
    let value = await getValue(remoteConfig, "rupin_web_wallet_nonideal").asBoolean();
    return value
  } catch {
    return false;
  }
};

//  Wrapper keeping same signature as Firebase for DEMO events

export const triggerLogEvent = (analyticsInstance, eventName, eventParams = {}) => {
  const isDemo = window.location.hostname.includes("web-demo");
  const finalName =
    isDemo && !eventName.startsWith("demo-")
      ? `demo-${eventName}`
      : eventName;

  firebaseLogEvent(analyticsInstance, finalName, eventParams);
};